/**
 * Kayit → "e-postani kontrol et" ekrani arasindaki devir verisi.
 *
 * Guvenlik: eski surum formun TAMAMINI (password/confirmPassword dahil) duz metin olarak
 * localStorage'a yaziyor ve hic silmiyordu. Onay ekraninin tek ihtiyaci e-posta adresi
 * (yeniden gonderim icin); bu yuzden YALNIZ e-posta saklanir. `purgeRegistrationSecrets`
 * eski surumden kalan parolali kayitlari uygulama acilisinda temizler.
 */
export const REGISTRATION_HANDOFF_KEY = 'registrationData';

export interface RegistrationHandoff {
    email: string;
}

export function saveRegistrationHandoff(email: string): void {
    localStorage.setItem(REGISTRATION_HANDOFF_KEY, JSON.stringify({ email } satisfies RegistrationHandoff));
}

/** Kaydi okur; eski surumun fazladan alanlarini (parola dahil) gorurse kaydi e-postaya indirger. */
export function readRegistrationHandoff(): RegistrationHandoff | null {
    const email = storedEmail();
    if (email === null) return null;
    saveRegistrationHandoff(email);
    return { email };
}

export function clearRegistrationHandoff(): void {
    localStorage.removeItem(REGISTRATION_HANDOFF_KEY);
}

/**
 * Uygulama acilisinda cagrilir: eski surumden kalan kaydi yalniz e-postaya indirger;
 * e-postasi olmayan ya da bozuk kaydi tamamen siler. localStorage erisilemezse
 * (gizli pencere vb.) acilisi bozmamak icin sessizce gecer -- temizlenecek bir sey de yoktur.
 */
export function purgeRegistrationSecrets(): void {
    try {
        if (localStorage.getItem(REGISTRATION_HANDOFF_KEY) === null) return;
        if (readRegistrationHandoff() === null) clearRegistrationHandoff();
    } catch {
        // localStorage erisilemiyor: kalici bir kayit da yok.
    }
}

function storedEmail(): string | null {
    const raw = localStorage.getItem(REGISTRATION_HANDOFF_KEY);
    if (!raw) return null;
    try {
        const parsed: unknown = JSON.parse(raw);
        const email = (parsed as { email?: unknown } | null)?.email;
        return typeof email === 'string' && email.length > 0 ? email : null;
    } catch {
        return null;
    }
}
